import { useSelector } from 'react-redux';

import { selectIsFeatureKratosCheckout } from 'selectors/features';
import type { AppState } from 'types/app';

const useKratosCheckoutEnabled = () => useSelector((state: AppState) => selectIsFeatureKratosCheckout(state));

export default useKratosCheckoutEnabled;
